import type { FirebaseOptions } from 'firebase/app';

export const firebaseConfig: FirebaseOptions = {
  apiKey: 'AIzaSyDjfvt05pKHnttJ5L7BAFir1gDEOczoAx4',
  authDomain: 'comandas-811c7.firebaseapp.com',
  databaseURL: 'https://comandas-811c7.firebaseio.com',
  projectId: 'comandas-811c7',
  storageBucket: 'comandas-811c7.appspot.com',
  messagingSenderId: '760566004836',
  appId: '1:760566004836:web:13719e65c3f13250',
  measurementId: 'G-RFZ5PC7M00',
};
